import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    title: 'Cases',
    loading: 'Loading cases...',
    empty: 'No cases available',
  },
  ru: {
    title: 'Кейсы',
    loading: 'Загрузка кейсов...',
    empty: 'Нет доступных кейсов',
  },
  uz: {
    title: 'Keyslar',
    loading: 'Keyslar yuklanmoqda...',
    empty: "Mavjud keyslar yo'q",
  },
});
